<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-07 14:55:46
 * @FilePath: \mrc-base-frontend\src\views\pushMessageLog\detailMessageLog.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-07 16:00:56
-->
<template>
  <Info />
</template>
<script>
import Info from "./modules/info.vue";
export default {
  components: { Info },
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
